













import Vue, { PropOptions } from 'vue'

export interface Category {
  id: number
  name: string
  slug: string
  count: number
}

export default Vue.extend({
  props: {
    categories: Array as PropOptions<Category[]>
  },

  data() {
    return {
      current: -1
    }
  },

  computed: {
    cats(): Category[] {
      if (this.categories.length === 0) return []
      return [
        { id: -1, name: 'All', slug: 'all', count: 99 },
        ...this.categories.filter(category => (category as Category).count > 0).sort((a, b) => b.count - a.count)
      ]
    }
  },

  methods: {
    applyFilter(id: number) {
      this.current = id
      this.$emit('apply-filter', this.current)
    },

    addTransitonDelay(el: HTMLElement) {
      el.style.transitionDelay = `${Number(el.dataset.index) * 100}ms`
    },

    removeTransitonDelay(el: HTMLElement) {
      el.style.transitionDelay = ''
    }
  }
})
